export const VIDEO_WALL_NOTIFICATION_FADE_MS = 5000;
export const VIDEO_WALL_NOTIFICATION_TIMEOUT_MS = 10 * 60 * 1000;
// How long the wall remembers a finished transaction while expectedFinishedTransactionMillis has not loaded (its
// backend default), so a late assignment for it is still ignored.
export const VIDEO_WALL_FINISHED_TRANSACTION_MEMORY_MS = 2 * 60 * 1000;
// Manual assign on an Unassigned lane stays disabled this long, so a click cannot race the
// automatic assignment (normally about 1s) and put the same truck on two desks.
export const VIDEO_WALL_UNASSIGNED_ASSIGN_DELAY_MS = 10 * 1000;

// Debounce window for broadcasting the local wall config to the SharedWorker. Long enough
// to coalesce rapid store updates (e.g. setRealTimeVideoWallCameras STOMP bursts) into a
// single postMessage, short enough that the config reaches other tabs before a user notices.
// Measure under realistic saturation load before adjusting.
export const VIDEO_WALL_CONFIG_PUBLISH_DEBOUNCE_MS = 150;
